import {IApiModel} from 'app/original-models/api-model.interface';
import {Role} from './role.model';
import {BaseGroup} from './group-base.model';
import moment from 'moment';
import {CreatedByDto} from '../models/company/integrations.model';

export class Company extends BaseGroup implements IApiModel<Company> {
    role: Role; //TODO: this field should be in User rights
    //commitlyPlan: string;
    type: string;
    phone: string;
    date_created: string | null;
    created_by: CreatedByDto | null;
    lastSync: any;
    website: string;
    bankAccounts: any[];
    isActive: boolean;
    isSelected: boolean;
    bankAccountsCount: number;
    teamMembersCount: number;
    declare tenant: any;
    tenantId: number;
    subscriptionPermissions: any;
    currentUserPermissions: string[];
    typeTranslate: string;
    countryTranslate: string;
    fiscalMonth: string;
    weeklyEmail: boolean;
    canReceiveWeeklyReport: boolean;
    planCount: number;
    companyGroup: number;
    parent: number;
    currency: string;
    expectedDateToggled: boolean;
    memberId: number;
    segments: string[];

    static getEmptyModel(id: number): Company {
        return new Company({
            id: id,
            name: '',
            type: '',
            fiscalYearEnding: '',
            country: '',
            phone: '',
            website: '',
            logo: '',
            logoContent: null,
            companyGroup: null,
            order: 0,
            currency: ''
        });
    }

    constructor(init?: Partial<Company>) {
        super(init);
        Object.assign(this, init);
    }

    getApiModel(): any {
        const formData = new FormData();
        if(this.id)
            formData.append('id', String(this.id));
        if(this.name)
            formData.append('name', this.name);
        if(this.type)
            formData.append('type', this.type);
        if(this.fiscalYearEnding)
            formData.append('fiscal_year_ending', this.fiscalYearEnding);
        if(this.country)
            formData.append('country', this.country);
        if(this.phone)
            formData.append('phone', this.phone);
        if(this.website)
            formData.append('website', this.website);
        if(this.currency)
            formData.append('currency', this.currency);
        if (this.order >= 0) {
            formData.append('order', String(this.order));
        }
        if (this.expectedDateToggled !== null && this.expectedDateToggled !== undefined) {
            formData.append('expected_date_toggled', this.expectedDateToggled.toString());
        }
        if (this.companyGroup) {
            formData.append('corporate_group', String(this.companyGroup));
        }
        if (this.logoContent !== undefined && this.logoContent !== null) {
            let name = this.logoContent === null ? null : this.logoContent.name;
            formData.append('logo', this.logoContent, name);
        }
        return formData;
    }


    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.type = apiModel.type;
        this.fiscalYearEnding = apiModel.fiscal_year_ending;
        this.country = apiModel.country;
        this.phone = apiModel.phone;
        this.website = apiModel.website;
        this.logo = apiModel.logo;
        this.lastSync = apiModel.last_sync || null;
        this.isActive = apiModel.is_active;
        this.bankAccountsCount = apiModel.bank_account_count;
        this.teamMembersCount = apiModel.team_member_count;
        this.planCount = apiModel.plan_count;
        this.tenantId = apiModel.tenant.id;
        this.tenant = apiModel.tenant;
        this.order = apiModel.order;
        this.currency = apiModel.currency;
        this.created_by = apiModel.created_by;
        this.currentUserRole = apiModel.current_user_groups ? apiModel.current_user_groups[0] : null;
        let permissions = apiModel.subscription_permissions;
        this.subscriptionPermissions = {};
        if (permissions) {
            if (!isNaN(permissions.bankaccounts)) {
                this.subscriptionPermissions.bankAccounts = permissions.bankaccounts;
            }
            if (!isNaN(permissions.companies)) {
                this.subscriptionPermissions.companies = permissions.companies;
            }
            if (!isNaN(permissions.teammembers)) {
                //workaround to fix basic
                this.subscriptionPermissions.teamMembers = permissions.teammembers === 1 ? 0 : permissions.teammembers;
            }
            this.subscriptionPermissions.creditRating = !!permissions.credit_rating;
            this.subscriptionPermissions.invoices = !!permissions.invoices;
            this.subscriptionPermissions.subscriptionStatus = permissions.subscription_status;
        }
        this.currentUserPermissions = apiModel.current_user_permissions;

        this.firstTransactionDate = apiModel.first_transaction_date
            ? moment(apiModel.first_transaction_date, 'YYYY-MM-DD').toDate() : null;
        if (apiModel.current_user_member_profile) {
            this.weeklyEmail = apiModel.current_user_member_profile.weekly_report;
            this.memberId = apiModel.current_user_member_profile.member_id;
        }
        this.companyGroup = this.parent = apiModel.corporate_group;
        this.expectedDateToggled = apiModel.expected_date_toggled;
        this.tags = apiModel.tags;
        this.segments = Array.isArray(apiModel.segments) ? apiModel.segments : [];
        return this;
    }

    isOwner(userId, userModel): boolean {
        return userModel === 'tenant' && userId === this.tenantId;
    }

    isAdvancedSubscription(): boolean {
        let teamMembers = this.subscriptionPermissions?.teamMembers;
        if (!isNaN(teamMembers)) {
            return teamMembers >= 5;
        }
        return true;
    }
}
